import React, {useState} from 'react';

import {useMediaSettingsDrawerContext} from '../../MediaSettingsDrawerContextProvider';
import {MasksForMediaKey} from './MasksForMediaKey';
import {MasksHeader} from './MasksHeader';

export const Masks = () => {
  const {allMasks} = useMediaSettingsDrawerContext();
  const [maskSearchRegex, setMaskSearchRegex] = useState<RegExp | null>(null);
  return (
    <div className="flex flex-col">
      <MasksHeader setMaskSearchRegex={setMaskSearchRegex} />
      {Object.keys(allMasks).map(mediaKey => {
        return (
          <MasksForMediaKey
            key={mediaKey}
            mediaKey={mediaKey}
            maskSearchRegex={maskSearchRegex}
          />
        );
      })}
    </div>
  );
};
